import React from "react";
import styled, { useTheme } from "styled-components";
import sortImg from "../../asserts/img/sortUp.svg";
import ReactSelect from "react-select";
import CreatableSelect from "react-select/creatable";
import { components } from "react-select";
import { useMobile } from "../../utils/mobile";
import { useTranslation } from "react-i18next";

const SelectContainer = styled.div(({ isMobile }) => ({
  fontSize: 15,
  position: isMobile && "relative",
}));

const StyledSelect = styled(ReactSelect)(() => ({}));
const StyledCreatableSelect = styled(CreatableSelect)(() => ({}));

const Error = styled.div(({ theme }) => ({
  fontSize: 12,
  color: theme.color.error,
}));

const Label = styled.div(({ theme }) => ({
  fontSize: 13,
  color: theme.color.label,
  textAlign: "start",
  fontWeight: 600,
  marginBottom: 5,
}));

const LabelMobile = styled("div")(({ theme, color, valid }) => ({
  fontSize: 13,
  color: valid === false ? theme.color.error : color || theme.color.label,
  fontWeight: 600,
  letterSpacing: 0.32,
  textAlign: "start",
  position: "relative",
  top: -20,
  backgroundColor: "#FFFFFF",
  width: `fit-content`,
  paddingInline: 6,
  marginInlineStart: 10,
  lineHeight: "12px",
}));

const StyleStartImg = styled.img(() => ({
  width: 22,
  height: 22,
  marginInlineStart: "1em",
  alignSelf: "center",
}));

const Select = ({
  label,
  value,
  error,
  name,
  options,
  onChange,
  width,
  height,
  helperText,
  startImg,
  placeholder,
  clearable,
  creatable,
  isMulti = false,
  openUp,
  ...props
}) => {
  const isMobile = useMobile();
  const theme = useTheme();
  const { i18n } = useTranslation();
  const isRtl = i18n.dir() === "rtl";

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <img src={sortImg} alt="input-sown-img" />
      </components.DropdownIndicator>
    );
  };

  const Control = ({ children, ...props }) => {
    return (
      <components.Control label {...props}>
        {!!startImg && !props.hasValue && (
          <StyleStartImg src={startImg} alt="input-start-img" />
        )}
        {isMobile && !!label && !!props.hasValue && (
          <LabelMobile startImg={startImg}>{label}</LabelMobile>
        )}
        {children}
      </components.Control>
    );
  };

  return (
    <SelectContainer style={{ ...props.style }}>
      {!!label && !isMobile && <Label startImg={startImg}>{label}</Label>}
      {creatable ? (
        <StyledCreatableSelect
          isClearable={clearable === false ? false : true}
          styles={{
            container: (base) => ({
              ...base,
              backgroundColor: theme.color.white,
              borderRadius: 8,
              width: width ? width : "100%",
              border:
                !!helperText === true
                  ? `1px solid ${theme.color.error}`
                  : `1px solid ${theme.color.darkGray}`,
            }),
            control: (base) => ({
              ...base,
              backgroundColor: theme.color.white,
              boxShadow: 0,
              border: 0,
              borderRadius: 10,
              height: height ? height : 41,
            }),
            input: (base) => ({
              ...base,
              textAlign: "start",
              color: theme.color.text,
            }),
            indicatorSeparator: () => {},
            indicatorsContainerCSS: {
              alignSelf: "flex-start",
            },
            menuList: (base) => ({
              ...base,
              marginRight: 5,
              zIndex: 9999,
            }),
            placeholder: (base) => ({
              ...base,
              textAlign: "start",
              color: theme.color.lightGray,
            }),
          }}
          isMulti={isMulti}
          closeMenuOnSelect={true}
          components={{ DropdownIndicator, Control }}
          options={options}
          mame={name}
          value={value}
          defaultValue={value}
          onChange={onChange}
          notEmpty={value !== "none"}
          placeholder={
            value && value !== "none" ? value : placeholder
          }></StyledCreatableSelect>
      ) : (
        <>
          <StyledSelect
            isClearable={clearable === false ? false : true}
            menuPlacement={openUp ? "top" : "auto"}
            styles={{
              container: (base) => ({
                ...base,
                backgroundColor: theme.color.white,
                borderRadius: 8,
                width: width ? width : "100%",
                border:
                  !!helperText === true
                    ? `1px solid ${theme.color.error}`
                    : `1px solid ${theme.color.darkGray}`,
              }),
              control: (base) => ({
                ...base,
                backgroundColor: theme.color.white,
                boxShadow: 0,
                border: 0,
                borderRadius: 10,
                height: height ? height : isMulti ? "auto" : 41,
                width: "100%",
              }),
              singleValue: (base) => ({
                ...base,
                width: width ? width : "100%",
              }),
              input: (base) => ({
                ...base,
                textAlign: "start",
                color: theme.color.text,
              }),
              indicatorSeparator: () => {},
              indicatorsContainerCSS: {
                alignSelf: "flex-start",
              },
              menuList: (base) => ({
                ...base,
                marginRight: 5,
              }),
              placeholder: (base) => ({
                ...base,
                textAlign: "start",
                color: theme.color.lightGray,
              }),
              valueContainer: (base) => ({
                ...base,
                right: isRtl && (!!isMobile && !!value && !!label ? 5 : 0),
                left: !isRtl && (!!isMobile && !!value && !!label ? 5 : 0),
                top: !!isMobile && !!value?.value && !!label && 5,
                position:
                  !!isMobile && !!value?.value && !!label
                    ? "absolute"
                    : "inherit",
              }),
            }}
            isMulti={isMulti}
            closeMenuOnSelect={true}
            components={{ DropdownIndicator, Control }}
            options={options}
            mame={name}
            value={value}
            defaultValue={value}
            onChange={onChange}
            notEmpty={value !== "none"}
            placeholder={
              value && value !== "none" ? value : placeholder
            }></StyledSelect>
        </>
      )}
      {!!helperText && <Error>{helperText}</Error>}
    </SelectContainer>
  );
};

export default Select;
